import React from 'react';
import { ATMHeader } from 'shared-it-appmod-ui';
import Lang from '../../../../../libraries/language';
import NewDispatchActionButtons from '../action-buttons/action-buttons.component';
import style from './new-dispatch-header.module.scss';

interface IProps {
  handleSave: (shouldReturn: boolean) => void;
  loading?: boolean;
}

const NewDispatchFormHeader: React.FC<IProps> = ({
  handleSave,
  loading = false,
}) => {
  return (
    <div className={style.header}>
      <ATMHeader
        as="h1"
        className={style.title}
        content={Lang.TTL_NEW_FIRE_DISPATCH_FORM}
      />
      <NewDispatchActionButtons handleSave={handleSave} loading={loading} />
    </div>
  );
};

export default NewDispatchFormHeader;
